export class ActbeValidaterFunctions {
  Require(val) {
    if (val == null || val === '') {
      return true
    } else {
      return false
    }
  }
  IsTime(date, time) {
    let date_conver = new Date(date)
    let selectDate = date_conver.getFullYear() + '-' + date_conver.getMonth() + '-' + date_conver.getDate()
    let now = new Date()
    let nowDate = now.getFullYear() + '-' + now.getMonth() + '-' + now.getDate()
    let nowHours = now.getHours()
    let nowMinutes = now.getMinutes()
    let selectPlace = time.indexOf(':')
    let selectHours = Number(time.substring(selectPlace, 0))
    let selectMinutes = Number(time.substring(selectPlace + 1, 10))
    if (selectDate === nowDate) {
      if (nowHours > selectHours) {
        return true
      } else if (nowHours === selectHours) {
        if (nowMinutes >= selectMinutes) {
          return true
        }
      }
    }
    return false
  }
  IsString(val) {
    return val.match(
      /^([0-9])|([０-９])|([\uFF65-\uFF9F])|([!"#$%&'()\*\+\-\.,\/:;<=>?@\[\\\]^_`{|}~])|(?:[！”＃＄％＆’（）＊＋，－．／：；＜＝＞？＠［￥］＾＿‘｛｜｝￣])|([、。・゛゜´｀¨ヽヾゝゞ〃仝〆〇ー―‐＼～〜∥…‥“〔〕〈〉《》「」『』【】±×÷≠≦≧∞∴♂♀°′″℃￠￡§☆★○●◎◇◇◆□■△▲▽▼※〒→←↑↓〓])+$/g
    )
      ? true
      : false
  }
  IsNumber(val) {
    return val.match(/^[0-9]+$/g) ? false : true
  }
  IsKana(val) {
    return val.match(/^([ァ-ヶー])+$/g) ? false : true
  }
  IsPostNumber(val) {
    // return (val.match(/^([\d])+$/g)) ? false : true;
    return val.match(/^[0-9\-]+$/g) ? false : true
  }
  IsAddress(val) {
    var regexp = /(北海道|東京都|(大阪|京都)府|(神奈川|和歌山|鹿児島)県|[^\s\w\d]{2}県)[^\s\w\d　]{1,6}[市郡区町村]*/g
    var result = val.match(regexp)
    if (result) {
      return false
    }
    return true
  }
  IsAddressKana(val) {
    if (!val) {
      return true
    }
    var regexp = /^[ァ-ヴa-zA-Zａ-ｚＡ-Ｚ0-9０-９\-ー‐‑–—―−－\s]+$/g
    var result = val.match(regexp)
    if (result) {
      return false
    }
    return true
  }
  IsEmail(val) {
    return val.match(/^[A-Za-z0-9]{1}[A-Za-z0-9_.+-]*@{1}[A-Za-z0-9_.-]{1,}\.[A-Za-z0-9]{1,}$/) ? false : true
  }
  IsFullWidth(val) {
    return val.match(/^[^\x01-\x7E\xA1-\xDF]+$/g) ? false : true
  }
  IsRange(val, min, max) {
    return min <= val && val <= max ? false : true
  }
  IsCompanyKana(val) {
    if (!val) {
      return true
    }
    var regexp = /^[ァ-ヴa-zA-Zａ-ｚＡ-Ｚ0-9０-９\-ー‐‑–—―−－&'.,＆’，．・\s]+$/g
    var result = val.match(regexp)
    if (result) {
      return false
    }
    return true
  }
  IsJust(val, just) {
    return val === just ? false : true
  }
  UnitLimit(val, limit) {
    return val % limit === 0 ? false : true
  }
  BanWord(val, ban) {
    const found = val.match(ban)
    return found ? true : false
  }
}
